<template>
  <div :id="`loader-block-${name}`"
    class="loader-block vs-con-loading__container"
    :class="{
      '_cover': cover,
      '_small': small
    }"
  >
    <slot v-if="hasDefaultSlot"/>
    <div v-else>
      <h6 v-if="!small" class="text-primary mt-32">Loading</h6>
    </div>
  </div>
</template>

<script>
const defaultName = makeid(5);

export default {
  name: "Loader",
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    }
  },
  props: {
    name: {
      type: String,
      default: defaultName
    },
    cover: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false
    },
    close: () => {
      this.closeLoader();
    }
  },
  methods: {
    openLoader(){
      this.$vs.loading({
        container: `#loader-block-${this.name}`,
        scale: 1
      })
    },
    closeLoader() {
      this.$vs.loading,close(`#loader-block-${this.name} > .con-vs-loading`)
    }
  },
  mounted() {
    this.openLoader();
  }
}

function makeid(length) {
   var result           = '';
   var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
   var charactersLength = characters.length;
   for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
   }
   return result;
}
</script>

<style lang="scss">
.loader-block {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &._cover {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  &._small {
    & .vs-loading {
      transform: scale(0.7) !important;
    }
  }
}
</style>
